// extracted by mini-css-extract-plugin
export default {"panel":"styles_panel__GFX1p","header":"styles_header__nDrFi"};